import React, { useState } from "react";
import RecordPage from "../../components/RecordPage";
import Modal from "../../components/Modal";
import FileViewer from "../../components/FileViewer";
import { formatDate, todayIso } from "../../core/format";

import { equipmentPrint, wornPrint } from "../../core/printConfigs";



const STATUS_LABEL = { healthy: "سالم", unusable: "غیرقابل استفاده" };
const box = { whiteSpace: "pre-wrap", lineHeight: 2, background: "var(--card-2)", border: "1px solid var(--border)", borderRadius: 10, padding: "10px 14px" };

const expiryBadge = (iso) => {
  if (!iso) return "—";
  const today = todayIso();
  const diff = new Date(`${iso}T00:00:00Z`) - new Date(`${today}T00:00:00Z`);
  const cls = iso < today ? "bad" : diff <= 30 * 86400000 ? "warn" : "ok";
  return <span className={`badge ${cls}`}>{formatDate(iso)}</span>;
};

function WornDetail({ row, onClose }) {
  const [viewer, setViewer] = useState(null);
  const items = [
    ["کد انبار فرسوده", row.code],
    ["کد انبار تجهیز", row.equipmentCode],
    ["نام تجهیزات", row.name],
    ["نوع تجهیزات", row.kind],
    ["محل قبلی", row.location],
    ["مسئول محل", row.supervisorName],
    ["شماره تماس مسئول", row.supervisorPhone],
    ["انقضا / شارژ بعدی", row.expiryDate ? formatDate(row.expiryDate) : "—"],
    ["تاریخ فرسودگی", formatDate(row.wearDate)],
    ["ثبت‌کننده", row.registeredByName],
    ["تأییدکننده", row.approvedByName],
  ];
  const file = (t) => `/warehouse/worn/${row.id}/file?type=${t}`;
  return (
    <>
      <Modal wide title={`تجهیزات فرسوده — ${row.code}`} onClose={() => !viewer && onClose()}
        footer={<button className="btn btn-ghost" onClick={onClose}>بستن</button>}>
        <div className="grid2">
          {items.map(([l, v]) => <div className="field" key={l}><label>{l}</label><div>{v || "—"}</div></div>)}
        </div>
        <div className="field"><label>علت فرسودگی</label><div style={box}>{row.reason}</div></div>
        {row.notes && <div className="field"><label>سابقه‌ی تغییرات تجهیز</label><div style={box}>{row.notes}</div></div>}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {row.hasWearFile && <button className="btn btn-ghost btn-sm" onClick={() => setViewer({ path: file("wear"), name: "فایل فرسودگی" })}>فایل فرسودگی</button>}
          {row.hasPhoto && <button className="btn btn-ghost btn-sm" onClick={() => setViewer({ path: file("photo"), name: "عکس تجهیزات" })}>عکس تجهیزات</button>}
        </div>
      </Modal>
      {viewer && <FileViewer {...viewer} onClose={() => setViewer(null)} />}
    </>
  );
}

export default function Warehouse() {
  const [tab, setTab] = useState("good");
  const [detail, setDetail] = useState(null);
  return (
    <>
      <div className="tabs">
        <button className={`tab-btn ${tab === "good" ? "on" : ""}`} onClick={() => setTab("good")}>انبار سالم</button>
        <button className={`tab-btn ${tab === "worn" ? "on" : ""}`} onClick={() => setTab("worn")}>انبار فرسوده</button>
      </div>

      {tab === "good" && (
        <RecordPage
        printReport={equipmentPrint}
          title="انبار سالم"
          subtitle="تجهیزاتی که در انبار نگهداری می‌شوند (از صفحه‌ی تجهیزات با تیک «انبار سالم» ثبت می‌شوند)"
          endpoint="/warehouse/good"
          fields={[]}
          columns={[
            { key: "code", label: "کد انبار", render: (r) => <b dir="ltr">{r.code || "—"}</b> },
            { key: "name", label: "نام تجهیزات", render: (r) => <b>{r.name}</b> },
            { key: "kind", label: "نوع تجهیزات" },
            { key: "status", label: "وضعیت", render: (r) => <span className={`badge ${r.status === "healthy" ? "ok" : "bad"}`}>{STATUS_LABEL[r.status]}</span> },
            { key: "supervisorName", label: "مسئول محل" },
            { key: "expiryDate", label: "انقضا / شارژ بعدی", render: (r) => expiryBadge(r.expiryDate) },
          ]}
        />
      )}

      {tab === "worn" && (
        <>
          <RecordPage
            title="انبار فرسوده"
            subtitle="تجهیزاتی که فرسودگی آن‌ها ثبت و تأیید شده است"
            printReport={wornPrint}
            endpoint="/warehouse/worn"
            fields={[]}
            columns={[
              { key: "code", label: "کد", render: (r) => <b dir="ltr">{r.code}</b> },
              { key: "equipmentCode", label: "کد انبار تجهیز", render: (r) => <span dir="ltr">{r.equipmentCode || "—"}</span> },
              { key: "name", label: "نام تجهیزات", render: (r) => <b>{r.name}</b> },
              { key: "kind", label: "نوع تجهیزات" },
              { key: "wearDate", label: "تاریخ فرسودگی", render: (r) => formatDate(r.wearDate) },
              { key: "reason", label: "علت", render: (r) => <div className="clip" title={r.reason}>{r.reason}</div> },
              { key: "registeredByName", label: "ثبت‌کننده" },
            ]}
            rowExtra={(r) => <button className="icon-btn" title="جزئیات" onClick={() => setDetail(r)}><i className="fa-solid fa-circle-info" /></button>}
          />
          {detail && <WornDetail row={detail} onClose={() => setDetail(null)} />}
        </>
      )}
    </>
  );
}